(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-media-autoplay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-card-video')) {
    class CollectionCardVideo extends HTMLElement {
      connectedCallback() {
        // Allow dynamically inserted markup to finish connecting.
        queueMicrotask(() => {
          if (!this.isConnected || this.observer) return;

          this.video = this.querySelector('video');
          if (!this.video) return;

          this.video.muted = true;
          this.video.playsInline = true;
          this.visible = false;
          this.slide = this.closest('slideshow-slide');

          this.updatePlayback = () => {
            const slideHidden = this.slide &&
              (this.slide.hidden ||
                this.slide.getAttribute('aria-hidden') === 'true');

            const shouldPlay =
              this.isConnected &&
              this.visible &&
              !document.hidden &&
              !slideHidden;

            if (shouldPlay) {
              if (this.video.paused) {
                this.video.play().catch(() => {
                  // Keep the poster visible if autoplay is blocked.
                });
              }
            } else {
              this.video.pause();
            }
          };

          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.visible =
                entry.isIntersecting && entry.intersectionRatio >= 0.5;
              this.updatePlayback();
            },
            { threshold: [0, 0.5] }
          );

          this.observer.observe(this);

          if (this.slide) {
            this.slideObserver = new MutationObserver(this.updatePlayback);
            this.slideObserver.observe(this.slide, {
              attributes: true,
              attributeFilter: ['aria-hidden', 'hidden']
            });
          }

          document.addEventListener(
            'visibilitychange',
            this.updatePlayback
          );
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.slideObserver?.disconnect();
        this.video?.pause();

        if (this.updatePlayback) {
          document.removeEventListener(
            'visibilitychange',
            this.updatePlayback
          );
        }

        this.observer = null;
        this.slideObserver = null;
      }
    }

    customElements.define('collection-card-video', CollectionCardVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ghost-thumbnail-picker')) {
    customElements.define('ghost-thumbnail-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const settings = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-ghost-index]');
          if (!choice || !this.contains(choice)) return;
          const select = this.querySelector('select');
          const details = this.querySelector('details');
          if (!select || !details) return;
          const index = Number(choice.dataset.ghostIndex);
          if (!select.options[index]) return;
          const changed = select.selectedIndex !== index;
          select.selectedIndex = index;
          this.querySelector('.ghost-picker__selected').replaceChildren(...Array.from(choice.childNodes, node => node.cloneNode(true)));
          this.querySelectorAll('[data-ghost-index]').forEach(button => {
            button.setAttribute('aria-pressed', String(Number(button.dataset.ghostIndex) === index));
          });
          details.open = false;
          details.querySelector('summary').focus();
          if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
        }, settings);
        this.addEventListener('keydown', (event) => {
          const details = this.querySelector('details');
          if (!details || !details.open) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            details.open = false;
            details.querySelector('summary').focus();
          }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const buttons = Array.from(this.querySelectorAll('[data-ghost-index]'));
            if (!buttons.length) return;
            const index = buttons.indexOf(document.activeElement);
            const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : buttons.length - 1) : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
            buttons[next].focus();
          }
        }, settings);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.querySelector('details')?.removeAttribute('open');
        }, settings);
        this.addEventListener('focusout', (event) => {
        // Safari may report no next focused element when an option is tapped.
        // Allow the option's click handler to finish instead of closing early.
        if (!event.relatedTarget) return;

        if (!this.contains(event.relatedTarget)) {
          this.querySelector('details')?.removeAttribute('open');
        }
      }, settings);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
